<template>
  <svg
    class="fill-current"
    :class="classObject"
    viewBox="0 0 147.5 191.2"
    @click="$emit('onClick')"
  >
    <g>
      <path class="st0" d="M125.7,50.4L75.1,0.7c-0.9-0.9-2.3-0.9-3.2,0L21.8,50.4c-1.1,1-1.5,2.6-1.1,4l11.5,44.5c0.2,0.8,0.6,1.5,1.2,2
        l38.6,36.6c0.4,0.4,1,0.6,1.6,0.6c0.6,0,1.1-0.2,1.6-0.6l38.8-36.6c0.6-0.6,1-1.3,1.2-2.1l11.7-44.6
        C127.1,52.9,126.7,51.4,125.7,50.4 M73.1,3.3l0.1,65.1L52,61.7c-0.7-0.4-1.8-1.4-1.5-3.1L73.1,3.3z M48.5,63.4
        c0.7-1,1.8-1.1,2.6-1.1l21.7,6.9L34.2,98.3L48.5,63.4z M95.5,62.5c0.6-0.2,2.2-0.4,3.3,0.9l14.4,34.9L74.7,69.2L95.5,62.5z
        M96.9,58.9c0.1,1.7-1.3,2.6-2,2.9l-20.8,6.6L74,3.3L96.9,58.9z M22.1,54c-0.2-1,0-2,0.7-2.7L72.7,1.9l-39.3,96L22.1,54z
        M74.2,136.5L74.2,136.5c-0.5,0.3-0.9,0.3-1.3,0L34.3,99.9c-0.1-0.1-0.2-0.2-0.3-0.3l39.7-30l39.5,30c-0.1,0.1-0.2,0.2-0.3,0.3
        L74.2,136.5z M125.5,53.9L114,97.9l-39.6-96l50.3,49.5C125.4,52.1,125.7,53,125.5,53.9"/>
      <path class="st0" d="M12.2,157.6c-0.4-2-2.5-2.8-4.4-2.8c-1.5,0-3.1,0.5-3.9,1.6c-0.4,0.6-0.6,1.3-0.5,2c0.2,2.2,2.6,2.5,4.9,2.7
        c3,0.4,6.7,1.1,7.5,4.6c0.1,0.5,0.2,1,0.2,1.4c0,4.2-4.2,6.6-8.1,6.6c-3.4,0-7.4-2-7.8-5.9l0-0.6l3.2-0.1l0,0.5v-0.1
        c0.2,2,2.7,3.1,4.7,3.1c2.3,0,4.9-1.3,4.9-3.5c0-0.2,0-0.5-0.1-0.7c-0.4-1.6-2.6-1.9-4.8-2.1c-3.4-0.3-7.4-1.1-7.7-5.6v0
        c-0.1-1.5,0.2-2.9,1.2-4.1c1.5-1.9,4.1-2.9,6.6-2.9c3.4,0,6.8,1.7,7.4,5.7L12.2,157.6z"/>
      <polygon class="st0" points="25.5,173.8 25.5,155.1 18.9,155.1 18.9,152 35.2,152 35.2,155.1 28.6,155.1 28.6,173.8"/>
      <path class="st0" d="M50,167.3h-7.8c-0.8,2-1.9,4.6-2.6,6.4h-3.4l8.7-22h2.3l8.7,22h-3.4L50,167.3z M43.4,164.3h5.4l-2.7-7.7
        L43.4,164.3z"/>
      <path class="st0" d="M64.7,162.7h3.7c2.6,0,3.9-1.9,3.9-3.8c0-1.9-1.3-3.8-3.9-3.8h-4.8v18.6h-3.1V152h7.9c4.7,0,7.1,3.5,7.1,6.9
        c0,3.1-1.9,6-5.6,6.6l6.9,8.2h-4.1l-7.9-9.5V162.7z"/>
      <path class="st0" d="M89.8,152c2.7,0,4.5,1.6,5.3,3.6c0.9,2.1,0.6,4.6-1.6,6.2c2.5,1.1,3.4,3.4,3.4,5.4c0,3.3-2.1,6.6-6.3,6.6h-9.8
        V152H89.8z M83.9,160.6h5.9c3.4,0,3.5-5.7,0.1-5.7h-5.9V160.6z M83.9,170.7h6.7c2.1,0,3.2-1.8,3.2-3.5c0-1.7-1.1-3.4-3.2-3.4h-6.7
        V170.7z"/>
      <path class="st0" d="M105.2,155c2-2,4.8-3.3,7.8-3.3c3.1,0,5.8,1.3,7.9,3.3c2,2,3.2,4.8,3.2,7.9c0,3.1-1.3,5.8-3.2,7.9
        c-2,2.1-4.8,3.3-7.9,3.3c-3,0-5.8-1.2-7.8-3.3c-2-2-3.2-4.8-3.2-7.9C102,159.8,103.2,157,105.2,155 M118.6,157.2
        c-1.5-1.5-3.5-2.4-5.6-2.4c-2.1,0-4.1,0.9-5.6,2.4c-1.4,1.4-2.3,3.4-2.3,5.6c0,2.2,0.9,4.2,2.3,5.6c1.4,1.5,3.4,2.4,5.6,2.4
        c2.1,0,4.2-0.9,5.6-2.4c1.4-1.4,2.3-3.4,2.3-5.6C120.9,160.6,120,158.6,118.6,157.2"/>
      <path class="st0" d="M131.2,152l5.9,8.1l5.9-8.1h3.8l-7.9,10.9c2.3,3.2,5.8,7.9,7.9,10.8H143l-5.9-8.1l-5.9,8.1h-3.9l7.9-10.8
        c-2.3-3.2-5.9-8.1-7.9-10.9H131.2z"/>
      <path class="st0" d="M3.6,183.8l1.6,4.2H1.9L3.6,183.8z M3.4,182.9l-3.3,8.2h0.6l1.1-2.6h3.7l1.1,2.6H7l-3.3-8.2H3.4z"/>
      <path class="st0" d="M16.9,187.9c1.6,0,2.5-1.2,2.5-2.4c0-1.2-0.9-2.4-2.5-2.4h-2.9v8.1h0.5v-7.6h2.3c1.4,0,2,1,2,1.9
        c0,0.9-0.6,1.9-2,1.9h-1.7v0.2h0l0,0v0.2l3.7,3.3h0.8l-3.6-3.2H16.9z"/>
      <path class="st0" d="M30.2,183.6c0.9,0,1.8,0.4,2.4,1c0.3,0.3,0.5,0.7,0.7,1l0,0.1H34l-0.1-0.2c-0.2-0.5-0.5-0.9-0.8-1.3
        c-0.7-0.8-1.7-1.2-2.8-1.2c-1.1,0-2.1,0.4-2.8,1.2c-0.7,0.8-1.2,1.8-1.2,2.8c0,1.1,0.4,2.1,1.2,2.9c0.7,0.8,1.7,1.2,2.8,1.2
        c1.1,0,2.1-0.4,2.8-1.2c0.4-0.4,0.6-0.8,0.8-1.3l0.1-0.2h-0.6l0,0.1c-0.2,0.4-0.4,0.7-0.7,1c-0.7,0.7-1.5,1-2.4,1
        c-0.9,0-1.8-0.4-2.4-1c-0.7-0.7-1-1.5-1-2.5c0-0.9,0.4-1.8,1-2.5C28.5,183.9,29.3,183.6,30.2,183.6"/>
      <polygon class="st0" points="46.3,183 46.3,186.8 41.8,186.8 41.8,183 41.3,183 41.3,191.1 41.8,191.1 41.8,187.3 46.3,187.3
        46.3,191.1 46.9,191.1 46.9,183"/>
      <polygon class="st0" points="54.2,183 54.2,183.5 55.8,183.5 55.8,190.6 54.2,190.6 54.2,191.1 58,191.1 58,190.6 56.3,190.6
        56.3,183.5 58,183.5 58,183"/>
      <polygon class="st0" points="64.9,183 64.9,183.6 67.6,183.6 67.6,191.1 68.1,191.1 68.1,183.6 70.8,183.6 70.8,183"/>
      <polygon class="st0" points="78,183 78,191 78,191.1 82.6,191.1 82.6,190.6 78.5,190.6 78.5,187.3 82.5,187.3 82.5,186.8
        78.5,186.8 78.5,183.6 82.6,183.6 82.6,183"/>
      <path class="st0" d="M93.7,183.6c0.9,0,1.8,0.4,2.4,1c0.3,0.3,0.5,0.7,0.7,1l0,0.1h0.6l-0.1-0.2c-0.2-0.5-0.5-0.9-0.8-1.3
        c-0.7-0.8-1.7-1.2-2.8-1.2s-2.1,0.4-2.8,1.2c-0.7,0.8-1.2,1.8-1.2,2.8c0,1.1,0.4,2.1,1.2,2.9c0.7,0.8,1.7,1.2,2.8,1.2
        c1.1,0,2.1-0.4,2.8-1.2c0.4-0.4,0.6-0.8,0.8-1.3l0.1-0.2h-0.6l0,0.1c-0.2,0.4-0.4,0.7-0.7,1c-0.7,0.7-1.5,1-2.4,1
        c-0.9,0-1.8-0.4-2.4-1c-0.7-0.7-1-1.5-1-2.5c0-0.9,0.4-1.8,1-2.5C91.9,183.9,92.8,183.6,93.7,183.6"/>
      <polygon class="st0" points="103.7,183 103.7,183.6 106.3,183.6 106.3,191.1 106.9,191.1 106.9,183.6 109.5,183.6 109.5,183"/>
      <path class="st0" d="M122,188.9c0,1.2-1.2,1.8-2.4,1.8c-1.1,0-2.4-0.6-2.4-1.8V183h-0.5v5.8c0,1.5,1.5,2.4,2.9,2.4
        c1.4,0,2.9-0.8,2.9-2.4V183H122V188.9z"/>
      <path class="st0" d="M133,187.9c1.6,0,2.5-1.2,2.5-2.4c0-1.2-0.9-2.4-2.5-2.4h-2.9v8.1h0.5v-7.6h2.3c1.4,0,2,1,2,1.9
        c0,0.9-0.6,1.9-2,1.9h-1.7v0.4l3.7,3.3h0.8l-3.6-3.2H133z"/>
      <polygon class="st0" points="142.9,183 142.9,191 142.9,191.1 147.5,191.1 147.5,190.6 143.4,190.6 143.4,187.3 147.4,187.3
        147.4,186.8 143.4,186.8 143.4,183.6 147.5,183.6 147.5,183"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'LogoStacked',
  props: {
    isLink: {
      type: Boolean,
      default: false
    },
    heightClass: {
      type: String,
      default: 'h-96'
    }
  },
  computed: {
    classObject () {
      return [
        this.heightClass,
        {
          'cursor-pointer': this.isLink
        }
      ]
    }
  },
  methods: {
  }
}
</script>
